import { Typography } from 'components/atoms';
import React, { useState } from 'react';
import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import { Link, useLocation } from 'react-router-dom';
import './index.scss';

const menuItemStyles = {};

export const AdminSidebar = () => {
  const location = useLocation();

  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="sidebar-wrapper">
      <Sidebar
        collapsed={collapsed}
        backgroundColor="#ffffff"
        style={{ border: 'none' }}
        collapsedWidth="110px"
      >
        <div className="sidebar-main-wrapper">
          <div className="sidebar-menus">
            <div className="sidebar-heading-wrapper">
              <Typography type="base_regular" text="Manager" />
            </div>

            <Menu menuItemStyles={menuItemStyles}>
              <MenuItem
                icon={<img src="/icons/dashboard.svg" alt="" />}
                component={<Link to="/admin/employee-summary-dashboard" />}
                active={
                  location.pathname === '/admin/employee-summary-dashboard'
                }
              >
                <span title="Dashboard" className="sidebar-menu-label">Dashboard</span>
              </MenuItem>
              <MenuItem
                icon={<img src="/icons/clock.svg" alt="" />}
                component={<Link to="/admin/employee-attendance" />}
                active={location.pathname === '/admin/employee-attendance'}
              >
                <span title="Attendance Summary" className="sidebar-menu-label">Attendance Summary</span>
              </MenuItem>
              <MenuItem
                icon={<img src="/icons/employee.svg" alt="" />}
                component={<Link to="/admin/add-employee" />}
                active={location.pathname === '/admin/add-employee'}
              >
                <span title="Add Employee" className="sidebar-menu-label">Add Employee</span>
              </MenuItem>
              <MenuItem
                icon={<img src="/icons/list-check.svg" alt="" />}
                component={<Link to="/admin/leave-summary" />}
                active={location.pathname === '/admin/leave-summary'}
              >
                <span title="Leave Summary" className="sidebar-menu-label">Leave Summary</span>
              </MenuItem>
              <MenuItem
                icon={<img src="/icons/summary_list.svg" alt="" />}
                component={<Link to="/admin" />}
                active={location.pathname === '/admin'}
              >
                <span title="Employee Summary" className="sidebar-menu-label">Employee Summary</span>
              </MenuItem>
              <MenuItem
                icon={<img src="/icons/check-double.svg" alt="" />}
                component={<Link to="/admin/all-leave-approvals" />}
                active={location.pathname === '/admin/all-leave-approvals'}
              >
                <span title="Leave Approvals" className="sidebar-menu-label">Leave Approvals</span>
              </MenuItem>
              <MenuItem
                icon={<img src="/icons/star.svg" alt="" />}
                component={<Link to="/admin/employee-review" />}
                active={location.pathname === '/admin/employee-review'}
              >
                <span title="Employee Review" className="sidebar-menu-label">Employee Review</span>
              </MenuItem>
            </Menu>

            <div className="sidebar-heading-wrapper">
              <Typography type="base_regular" text="Other" />
            </div>

            <Menu menuItemStyles={menuItemStyles}>
              <MenuItem
                icon={<img src="/icons/calendar-check.svg" alt="" />}
                component={<Link to="/admin/annual-leave-allocation" />}
                active={location.pathname === '/admin/annual-leave-allocation'}
              >
                <span title="Leave Allocation" className="sidebar-menu-label">Leave Allocation</span>
              </MenuItem>
              <MenuItem
                icon={<img src="/icons/heart.svg" alt="" />}
                component={<Link to="/admin/maternity-leave-allocation" />}
                active={location.pathname === '/admin/maternity-leave-allocation'}
              >
                <span title="Maternity Leave Allocation" className="sidebar-menu-label">Maternity Leave Allocation</span>
              </MenuItem>
              <MenuItem
                icon={<img src="/icons/calendar-event.svg" alt="" />}
                component={<Link to="/admin/public-holiday-upload" />}
                active={location.pathname === '/admin/public-holiday-upload'}
              >
                <span title="Public Holiday Upload" className="sidebar-menu-label">Public Holiday Upload</span>
              </MenuItem>
              <MenuItem
                icon={<img src="/icons/user-star.svg" alt="" />}
                component={<Link to="/admin/hr-manager" />}
                active={location.pathname === '/admin/hr-manager'}
              >
                <span title="HR Manager" className="sidebar-menu-label">HR Manager</span>
              </MenuItem>
              <MenuItem
                icon={<img src="/icons/log.svg" alt="" />}
                active={false}
                disabled
              >
                <span title="Activity Log" className="sidebar-menu-label">Activity Log</span>
              </MenuItem>
            </Menu>
          </div>

          <div
            className={
              collapsed ? 'collapsed sidebar-footer' : 'sidebar-footer'
            }
          >
            <div />
            <button
              className="collapse-btn"
              type="button"
              onClick={() => setCollapsed(!collapsed)}
            >
              <img src="/icons/collapse.svg" alt="" />
              {!collapsed ? <span>Collapse</span> : null}
            </button>
          </div>
        </div>
      </Sidebar>
    </div>
  );
};
